import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeline-container-mobile mx-3 d-block d-lg-none" }
const _hoisted_2 = { class: "eurostar-hero-mobile mb-3" }
const _hoisted_3 = { class: "timeline-title-mobile heading text-white mb-3" }
const _hoisted_4 = { class: "d-block fw-normal" }
const _hoisted_5 = { class: "eurostar-pill" }
const _hoisted_6 = { class: "d-flex mb-1" }
const _hoisted_7 = { class: "timeline-content-mobile pb-2" }
const _hoisted_8 = { class: "timeline-text-mobile label-blue" }
const _hoisted_9 = { class: "timeline-detail-mobile" }
const _hoisted_10 = { class: "custom-badge-mobile badge-train-mobile" }
const _hoisted_11 = { class: "d-flex mb-1" }
const _hoisted_12 = { class: "timeline-content-mobile pb-2" }
const _hoisted_13 = { class: "timeline-text-mobile label-blue" }
const _hoisted_14 = { class: "timeline-detail-mobile" }
const _hoisted_15 = { class: "custom-badge-mobile badge-stay-orange-mobile" }
const _hoisted_16 = { class: "d-flex mb-1" }
const _hoisted_17 = { class: "timeline-content-mobile pb-2" }
const _hoisted_18 = { class: "timeline-text-mobile label-orange" }
const _hoisted_19 = { class: "d-flex mb-1" }
const _hoisted_20 = { class: "timeline-content-mobile pb-2" }
const _hoisted_21 = { class: "timeline-text-mobile label-grey" }
const _hoisted_22 = { class: "timeline-detail-mobile" }
const _hoisted_23 = { class: "d-flex mb-1" }
const _hoisted_24 = { class: "timeline-content-mobile pb-2" }
const _hoisted_25 = { class: "timeline-text-mobile label-grey" }
const _hoisted_26 = { class: "timeline-detail-mobile" }
const _hoisted_27 = { class: "custom-badge-mobile badge-night-mobile" }
const _hoisted_28 = { class: "d-flex mb-1" }
const _hoisted_29 = { class: "timeline-content-mobile pb-2" }
const _hoisted_30 = { class: "timeline-text-mobile label-blue" }
const _hoisted_31 = { class: "timeline-detail-mobile" }
const _hoisted_32 = { class: "custom-badge-mobile badge-train-mobile" }
const _hoisted_33 = { class: "d-flex" }
const _hoisted_34 = { class: "timeline-content-mobile" }
const _hoisted_35 = { class: "timeline-text-mobile label-blue mb-0" }
const _hoisted_36 = { class: "timeline-detail-mobile" }
const _hoisted_37 = { class: "timeline-section d-none d-lg-flex" }
const _hoisted_38 = { class: "eurostar-hero" }
const _hoisted_39 = { class: "eurostar-headline" }
const _hoisted_40 = { class: "d-block" }
const _hoisted_41 = { class: "eurostar-pill" }
const _hoisted_42 = { class: "timeline-track-wrap" }
const _hoisted_43 = { class: "timeline-track" }
const _hoisted_44 = { class: "flag flag-blue flag-seg-1" }
const _hoisted_45 = { class: "flag flag-orange flag-point-3" }
const _hoisted_46 = { class: "flag flag-grey flag-point-5" }
const _hoisted_47 = { class: "flag flag-blue flag-seg-6" }
const _hoisted_48 = { class: "label-cell label-blue tlc-1" }
const _hoisted_49 = { class: "label-head" }
const _hoisted_50 = { class: "label-detail" }
const _hoisted_51 = { class: "label-cell label-blue tlc-2" }
const _hoisted_52 = { class: "label-head" }
const _hoisted_53 = { class: "label-detail" }
const _hoisted_54 = { class: "label-cell label-orange tlc-3" }
const _hoisted_55 = { class: "label-head" }
const _hoisted_56 = { class: "label-cell label-grey tlc-4" }
const _hoisted_57 = { class: "label-head" }
const _hoisted_58 = { class: "label-detail" }
const _hoisted_59 = { class: "label-cell label-grey tlc-5" }
const _hoisted_60 = { class: "label-head" }
const _hoisted_61 = { class: "label-detail" }
const _hoisted_62 = { class: "label-cell label-blue tlc-6" }
const _hoisted_63 = { class: "label-head" }
const _hoisted_64 = { class: "label-detail" }
const _hoisted_65 = { class: "label-cell label-blue tlc-7" }
const _hoisted_66 = { class: "label-head" }
const _hoisted_67 = { class: "label-detail" }

import { computed } from "vue"
import { useStore } from "vuex"

import TrainSvgIcon from "./svg/trainSvgIcon.vue"
import SkiSvgIcon from "./svg/skiSvgIcon.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'EurostarTimeLine',
  setup(__props) {

const store = useStore()
const content = computed(() => store.state.content || {})

const t = (key: string, fallback: string) => content.value[key] || fallback

const originCode = computed(() => store.state.flightOrigin?.split("-")[0] || "")

const trainStationName = computed(() => {
  return content.value["planning_traintimeline_station"][originCode.value]?.short || ""
})

const stationLabel = computed(() => {
  if (originCode.value === "STP") return t("planning_eurostar_station", "Station")
  return trainStationName.value || t("planning_eurostar_station", "Station")
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"eurostar-logo d-flex align-items-center gap-2 mb-2\" data-v-f173e7da><span class=\"eurostar-logo-box\" data-v-f173e7da><svg width=\"18\" height=\"18\" viewBox=\"40.29 7.02 35.46 42.47\" fill=\"none\" aria-hidden=\"true\" data-v-f173e7da><path d=\"M73.1898 22.3771L70.5252 19.6523C70.0272 19.1431 69.2185 19.1431 68.7205 19.6523L65.2704 23.1803L58.9195 16.6861C58.6807 16.4419 58.3547 16.3028 58.0158 16.3028C57.677 16.3028 57.3535 16.4393 57.1122 16.6861L50.7613 23.1803L47.3112 19.6523C47.0724 19.4082 46.7464 19.2691 46.4076 19.2691C46.0687 19.2691 45.7452 19.4056 45.5039 19.6523L42.8445 22.3718V14.3367C42.8445 13.7224 43.2937 13.2027 43.8893 13.1292L71.8524 9.61956C71.9037 9.61431 71.9525 9.60906 72.0013 9.60906C72.2913 9.60906 72.5634 9.71406 72.7842 9.91619C73.0435 10.1498 73.1847 10.4753 73.1847 10.8271V22.3771H73.1898ZM73.1898 28.2334C73.1898 29.3569 71.8601 29.9187 71.0848 29.1259L67.075 25.0257L68.7488 23.3142C69.2314 22.8207 70.0118 22.8207 70.4944 23.3142L73.1898 26.0704V28.2334ZM64.6107 29.3937L60.6728 28.9107C60.3596 28.8713 60.0464 28.9579 59.7923 29.1495L56.3421 31.7588C55.4128 32.4597 54.1344 31.5908 54.4117 30.4437L55.3949 26.346L56.8119 20.9202C57.0558 19.9831 58.2032 19.6681 58.8758 20.3532L62.7624 24.3195L65.6323 27.249C66.4615 28.0969 65.7761 29.538 64.6132 29.3937M59.9745 39.9094H59.0555V41.5658C59.0555 42.0225 59.2968 42.1354 59.6126 42.1354C59.6742 42.1354 59.7204 42.1354 59.782 42.1223V44.2617C59.6742 44.2984 59.456 44.3352 59.189 44.3352C57.5307 44.3352 56.6373 43.5319 56.6373 41.7994V39.9068H55.7671V37.791H56.6373V36.2029L59.0555 35.8984V37.791H59.9745V39.9068V39.9094ZM44.952 29.1207C44.1742 29.916 42.847 29.3517 42.847 28.2282V26.0652L45.5373 23.3142C46.0199 22.8207 46.8003 22.8207 47.2829 23.3142L48.9567 25.0257L44.952 29.1207ZM74.481 7.96057C73.6776 7.23344 72.6071 6.89482 71.5443 7.02869L43.5812 10.5383C41.7072 10.7746 40.2928 12.4073 40.2928 14.3393V31.365C40.2928 41.3584 48.2456 49.4906 58.0184 49.4906C67.7913 49.4906 75.744 41.3584 75.744 31.365V10.8271C75.744 9.72981 75.2845 8.68507 74.481 7.96057Z\" fill=\"#FFFFFF\" data-v-f173e7da></path></svg></span><span class=\"eurostar-logo-text\" data-v-f173e7da><strong data-v-f173e7da>travelski</strong> express</span></div>", 1)),
        _createElementVNode("h2", _hoisted_3, [
          _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_headline_bold', 'Get from London to the French Alps')), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(t('planning_eurostar_headline_regular', 'on Saturdays and return Sundays.')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("svg", {
            width: "16",
            height: "16",
            class: "icon"
          }, [
            _createElementVNode("use", { "xlink:href": "#___icon___home" })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(t('planning_eurostar_nights_resort', '7 nights in resort')) + " ", 1),
          _cache[1] || (_cache[1] = _createElementVNode("span", null, "+", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("svg", {
            width: "16",
            height: "16",
            class: "icon"
          }, [
            _createElementVNode("use", { "xlink:href": "#___icon___night" })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(t('planning_eurostar_night_station', '1 night near station')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile point-ring-blue" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-blue-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(t('planning_eurostar_morning', 'Morning')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_departure', 'Departure')), 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(t('planning_eurostar_outbound_from', 'London St Pancras')) + " → " + _toDisplayString(stationLabel.value), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(TrainSvgIcon, {
              color: "var(--primary-blue)",
              width: 16,
              height: 16,
              fill: "var(--primary-blue)",
              stroke: "var(--primary-blue)"
            }),
            _createTextVNode(" " + _toDisplayString(t('planning_eurostar_saturday', 'Saturday')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile point-ring-orange" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-orange-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createTextVNode(_toDisplayString(t('planning_eurostar_evening', 'Evening')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_arrival', 'Arrival')), 1),
            _createElementVNode("span", _hoisted_14, _toDisplayString(t('planning_eurostar_transfer_resort', 'Transfert to resort')), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(SkiSvgIcon, {
              color: "#f56600",
              width: 16,
              height: 16,
              fill: "#f56600",
              stroke: "#f56600"
            }),
            _createTextVNode(" " + _toDisplayString(t('planning_eurostar_7days', '7 days')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile point-fill-orange" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-orange-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createTextVNode(_toDisplayString(t('planning_eurostar_7days', '7 days')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_enjoy', 'Enjoy your holiday')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile point-ring-grey" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-lightgrey-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createTextVNode(_toDisplayString(t('planning_eurostar_afterski', 'After skiing')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_after_skiing_short', 'Transfer')), 1),
            _createElementVNode("span", _hoisted_22, _toDisplayString(t('planning_eurostar_transfer_hotel', 'Transfer to hotel in the vicinity of the train station')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile point-fill-grey" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-lightgrey-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createTextVNode(_toDisplayString(t('planning_eurostar_night', 'Night')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_night_stay', '1 night stay')), 1),
            _createElementVNode("span", _hoisted_26, _toDisplayString(t('planning_eurostar_night_rest', "A night's rest in a hotel closer to the station")), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[8] || (_cache[8] = _createElementVNode("svg", {
              width: "16",
              height: "16",
              class: "icon"
            }, [
              _createElementVNode("use", { "xlink:href": "#___icon___night" })
            ], -1)),
            _createTextVNode(" " + _toDisplayString(t('planning_eurostar_saturday', 'Saturday')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile point-ring-blue" }),
          _createElementVNode("div", { class: "timeline-line-mobile line-blue-mobile flex-grow-1" })
        ], -1)),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createTextVNode(_toDisplayString(t('planning_eurostar_morning', 'Morning')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_departure', 'Departure')), 1),
            _createElementVNode("span", _hoisted_31, _toDisplayString(stationLabel.value) + " → " + _toDisplayString(t('planning_eurostar_outbound_from', 'London St Pancras')), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(TrainSvgIcon, {
              color: "var(--primary-blue)",
              width: 16,
              height: 16,
              fill: "var(--primary-blue)",
              stroke: "var(--primary-blue)"
            }),
            _createTextVNode(" " + _toDisplayString(t('planning_eurostar_sunday', 'Sunday')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "timeline-visual-mobile d-flex flex-column align-items-center me-3" }, [
          _createElementVNode("div", { class: "timeline-point-mobile point-ring-blue" })
        ], -1)),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createTextVNode(_toDisplayString(t('planning_eurostar_evening', 'Evening')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_arrival', 'Arrival')), 1),
            _createElementVNode("span", _hoisted_36, _toDisplayString(t('planning_eurostar_arrival_london', 'Arrival London St Pancras')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"eurostar-logo d-flex align-items-center gap-2\" data-v-f173e7da><span class=\"eurostar-logo-box\" data-v-f173e7da><svg width=\"18\" height=\"18\" viewBox=\"40.29 7.02 35.46 42.47\" fill=\"none\" aria-hidden=\"true\" data-v-f173e7da><path d=\"M73.1898 22.3771L70.5252 19.6523C70.0272 19.1431 69.2185 19.1431 68.7205 19.6523L65.2704 23.1803L58.9195 16.6861C58.6807 16.4419 58.3547 16.3028 58.0158 16.3028C57.677 16.3028 57.3535 16.4393 57.1122 16.6861L50.7613 23.1803L47.3112 19.6523C47.0724 19.4082 46.7464 19.2691 46.4076 19.2691C46.0687 19.2691 45.7452 19.4056 45.5039 19.6523L42.8445 22.3718V14.3367C42.8445 13.7224 43.2937 13.2027 43.8893 13.1292L71.8524 9.61956C71.9037 9.61431 71.9525 9.60906 72.0013 9.60906C72.2913 9.60906 72.5634 9.71406 72.7842 9.91619C73.0435 10.1498 73.1847 10.4753 73.1847 10.8271V22.3771H73.1898ZM73.1898 28.2334C73.1898 29.3569 71.8601 29.9187 71.0848 29.1259L67.075 25.0257L68.7488 23.3142C69.2314 22.8207 70.0118 22.8207 70.4944 23.3142L73.1898 26.0704V28.2334ZM64.6107 29.3937L60.6728 28.9107C60.3596 28.8713 60.0464 28.9579 59.7923 29.1495L56.3421 31.7588C55.4128 32.4597 54.1344 31.5908 54.4117 30.4437L55.3949 26.346L56.8119 20.9202C57.0558 19.9831 58.2032 19.6681 58.8758 20.3532L62.7624 24.3195L65.6323 27.249C66.4615 28.0969 65.7761 29.538 64.6132 29.3937M59.9745 39.9094H59.0555V41.5658C59.0555 42.0225 59.2968 42.1354 59.6126 42.1354C59.6742 42.1354 59.7204 42.1354 59.782 42.1223V44.2617C59.6742 44.2984 59.456 44.3352 59.189 44.3352C57.5307 44.3352 56.6373 43.5319 56.6373 41.7994V39.9068H55.7671V37.791H56.6373V36.2029L59.0555 35.8984V37.791H59.9745V39.9068V39.9094ZM44.952 29.1207C44.1742 29.916 42.847 29.3517 42.847 28.2282V26.0652L45.5373 23.3142C46.0199 22.8207 46.8003 22.8207 47.2829 23.3142L48.9567 25.0257L44.952 29.1207ZM74.481 7.96057C73.6776 7.23344 72.6071 6.89482 71.5443 7.02869L43.5812 10.5383C41.7072 10.7746 40.2928 12.4073 40.2928 14.3393V31.365C40.2928 41.3584 48.2456 49.4906 58.0184 49.4906C67.7913 49.4906 75.744 41.3584 75.744 31.365V10.8271C75.744 9.72981 75.2845 8.68507 74.481 7.96057Z\" fill=\"#FFFFFF\" data-v-f173e7da></path></svg></span><span class=\"eurostar-logo-text\" data-v-f173e7da><strong data-v-f173e7da>travelski</strong> express</span></div>", 1)),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_headline_bold', 'Get from London to the French Alps')), 1),
          _createElementVNode("span", _hoisted_40, _toDisplayString(t('planning_eurostar_headline_regular', 'on Saturdays and return Sundays.')), 1)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _cache[12] || (_cache[12] = _createElementVNode("svg", {
            width: "16",
            height: "16",
            class: "icon"
          }, [
            _createElementVNode("use", { "xlink:href": "#___icon___home" })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(t('planning_eurostar_nights_resort', '7 nights in resort')) + " ", 1),
          _cache[13] || (_cache[13] = _createElementVNode("span", null, "+", -1)),
          _cache[14] || (_cache[14] = _createElementVNode("svg", {
            width: "16",
            height: "16",
            class: "icon"
          }, [
            _createElementVNode("use", { "xlink:href": "#___icon___night" })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(t('planning_eurostar_night_station', '1 night near station')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createVNode(TrainSvgIcon, {
              color: "var(--primary-blue)",
              width: 16,
              height: 16,
              fill: "var(--primary-blue)",
              stroke: "var(--primary-blue)"
            }),
            _createTextVNode(" " + _toDisplayString(t('planning_eurostar_saturday', 'Saturday')), 1)
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(SkiSvgIcon, {
              color: "#f56600",
              width: 16,
              height: 16,
              fill: "#f56600",
              stroke: "#f56600"
            }),
            _createTextVNode(" " + _toDisplayString(t('planning_eurostar_7days', '7 days')), 1)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _cache[16] || (_cache[16] = _createElementVNode("svg", {
              width: "15",
              height: "15",
              class: "icon"
            }, [
              _createElementVNode("use", { "xlink:href": "#___icon___night" })
            ], -1)),
            _createTextVNode(" " + _toDisplayString(t('planning_eurostar_saturday', 'Saturday')), 1)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(TrainSvgIcon, {
              color: "var(--primary-blue)",
              width: 16,
              height: 16,
              fill: "var(--primary-blue)",
              stroke: "var(--primary-blue)"
            }),
            _createTextVNode(" " + _toDisplayString(t('planning_eurostar_sunday', 'Sunday')), 1)
          ]),
          _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"line-cell tlc-1\" data-v-f173e7da><span class=\"half half-none\" data-v-f173e7da></span><span class=\"dot dot-ring-blue\" data-v-f173e7da></span><span class=\"half half-blue\" data-v-f173e7da></span></div><div class=\"line-cell tlc-2\" data-v-f173e7da><span class=\"half half-blue\" data-v-f173e7da></span><span class=\"dot dot-ring-orange\" data-v-f173e7da></span><span class=\"half half-orange\" data-v-f173e7da></span></div><div class=\"line-cell tlc-3\" data-v-f173e7da><span class=\"half half-orange\" data-v-f173e7da></span><span class=\"dot dot-fill-orange\" data-v-f173e7da></span><span class=\"half half-orange\" data-v-f173e7da></span></div><div class=\"line-cell tlc-4\" data-v-f173e7da><span class=\"half half-orange\" data-v-f173e7da></span><span class=\"dot dot-ring-grey\" data-v-f173e7da></span><span class=\"half half-lightgrey\" data-v-f173e7da></span></div><div class=\"line-cell tlc-5\" data-v-f173e7da><span class=\"half half-lightgrey\" data-v-f173e7da></span><span class=\"dot dot-fill-grey\" data-v-f173e7da></span><span class=\"half half-lightgrey\" data-v-f173e7da></span></div><div class=\"line-cell tlc-6\" data-v-f173e7da><span class=\"half half-lightgrey\" data-v-f173e7da></span><span class=\"dot dot-ring-blue\" data-v-f173e7da></span><span class=\"half half-blue\" data-v-f173e7da></span></div><div class=\"line-cell tlc-7\" data-v-f173e7da><span class=\"half half-blue\" data-v-f173e7da></span><span class=\"dot dot-ring-blue\" data-v-f173e7da></span><span class=\"half half-none\" data-v-f173e7da></span></div>", 7)),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("span", _hoisted_49, [
              _createTextVNode(_toDisplayString(t('planning_eurostar_morning', 'Morning')), 1),
              _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_departure', 'Departure')), 1)
            ]),
            _createElementVNode("span", _hoisted_50, _toDisplayString(t('planning_eurostar_outbound_from', 'London St Pancras')) + " → " + _toDisplayString(stationLabel.value), 1)
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("span", _hoisted_52, [
              _createTextVNode(_toDisplayString(t('planning_eurostar_evening', 'Evening')), 1),
              _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_arrival', 'Arrival')), 1)
            ]),
            _createElementVNode("span", _hoisted_53, _toDisplayString(t('planning_eurostar_transfer_resort', 'Transfert to resort')), 1)
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("span", _hoisted_55, [
              _createTextVNode(_toDisplayString(t('planning_eurostar_7days', '7 days')), 1),
              _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_enjoy', 'Enjoy your holiday')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("span", _hoisted_57, [
              _createTextVNode(_toDisplayString(t('planning_eurostar_afterski', 'After skiing')), 1),
              _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_after_skiing_short', 'Transfer')), 1)
            ]),
            _createElementVNode("span", _hoisted_58, _toDisplayString(t('planning_eurostar_transfer_hotel', 'Transfer to hotel in the vicinity of the train station')), 1)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("span", _hoisted_60, [
              _createTextVNode(_toDisplayString(t('planning_eurostar_night', 'Night')), 1),
              _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_night_stay', '1 night stay')), 1)
            ]),
            _createElementVNode("span", _hoisted_61, _toDisplayString(t('planning_eurostar_night_rest', "A night's rest in a hotel closer to the station")), 1)
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("span", _hoisted_63, [
              _createTextVNode(_toDisplayString(t('planning_eurostar_morning', 'Morning')), 1),
              _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_departure', 'Departure')), 1)
            ]),
            _createElementVNode("span", _hoisted_64, _toDisplayString(stationLabel.value) + " → " + _toDisplayString(t('planning_eurostar_outbound_from', 'London St Pancras')), 1)
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("span", _hoisted_66, [
              _createTextVNode(_toDisplayString(t('planning_eurostar_evening', 'Evening')), 1),
              _createElementVNode("strong", null, _toDisplayString(t('planning_eurostar_arrival', 'Arrival')), 1)
            ]),
            _createElementVNode("span", _hoisted_67, _toDisplayString(t('planning_eurostar_arrival_london', 'Arrival London St Pancras')), 1)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})